





























































































































































































































































































































































































import { MemberManagementMemberService as memberApi } from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import MemberEventNumberQrCodeComponent from "@/components/admin/member/memberEventNumberQrCodeComponent.vue";
import PostalCode from "@/components/common/postalCode.vue";
import {
  LANGUAGES,
  LANGUAGES_NAME,
  NOTICES,
  RECEIVE_NEWS_LETTERS,
  STATUS_CONFIRM_NAME,
  STATUS_NAME,
  STATUSES,
  STATUSES_CONFIRM,
  TYPES,
  TYPES_NAME,
} from "@/model/member";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MemberInfoComponent",
  components: {
    QErrors,
    PostalCode,
    MemberEventNumberQrCodeComponent,
  },
})
export default class MemberInfoComponent extends Vue {
  public title = "会員の新規作成";
  public memberId = null;
  public errors = {};
  public errorStyle = {
    width: "inherit",
    // marginBottom: "1rem",
    // textAlign: "left",
  };
  public form: any = {
    lastName: null,
    firstName: null,
    lastKana: null,
    firstKana: null,
    type: TYPES.CONSUMER,
    companyName: null,
    nickname: null,
    zip: null,
    address1: null,
    address2: null,
    address3: null,
    tel: null,
    telDaytime: null,
    email: null,
    password: null,
    language: LANGUAGES.JP,
    isNewsletter: true,
    isNotice: true,
    status: STATUSES.AVAILABLE,
    eventHash: null,
    eventHashUrl: null,
    eventNumber: null,
    statusConfirm: STATUSES_CONFIRM.CONFIRMED,
  };
  public originalForm: any = {};

  public isNewsletter = true;
  public isNotice = true;

  get types() {
    return TYPES_NAME;
  }

  get languages() {
    return LANGUAGES_NAME;
  }

  get receiveNewsLetters() {
    return RECEIVE_NEWS_LETTERS;
  }

  get notices() {
    return NOTICES;
  }

  get statuses() {
    return STATUS_NAME;
  }

  get statusConfirmes() {
    return STATUS_CONFIRM_NAME;
  }

  get isDealer() {
    return this.form.type === TYPES.BUSINESS;
  }

  get isEvent() {
    return this.form.type === TYPES.EVENT;
  }

  get isMania() {
    return this.form.type === TYPES.MANIA;
  }

  get isAddPage() {
    return this.$router.currentRoute.name === "admin.member.add";
  }

  get isEditableEmailPasword() {
    if (this.isAddPage && this.isEvent) {
      return false;
    }
    return true;
  }

  public async show(member: any = {}) {
    this.memberId = this.$router.currentRoute.params?.id;

    if (this.memberId) {
      this.form = member;
    }

    this.originalForm = JSON.parse(JSON.stringify(this.form));
  }

  public async setNewEventNumber() {
    try {
      const result = await memberApi.adminMemberNewEventNumber({
        id: this.memberId,
      });
      this.form.eventNumber = result.data?.eventNumer;
    } catch (error) {
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  public copyEventHashUrl() {
    if (this.form.eventHashUrl) {
      navigator.clipboard.writeText(this.form.eventHashUrl);
      QNotify.success({
        text: this.$t("店舗会員専用URLをコピーしました。"),
      });
    }
  }

  public showEventNumberQRCode() {
    (
      this.$refs
        .memberEventNumberQrCodeComponent as MemberEventNumberQrCodeComponent
    ).show(this.form.eventHashUrl);
  }

  public async submit() {
    const parameters = {
      ...this.form,
      isNewsletter: this.form.isNewsletter.toString() == "true",
      isNotice: this.form.isNotice.toString() == "true",
    };
    let result;
    try {
      result = this.memberId
        ? await memberApi.adminMemberEdit({
            ...parameters,
            ...{ id: this.memberId },
          })
        : await memberApi.adminMemberCreate(parameters);

      QNotify.success({
        text: this.memberId
          ? this.$t("common.message.updated")
          : this.$t("common.message.created"),
      });
      this.$router.go(-1);
    } catch (error: any) {
      result = error.body;
      QNotify.error({
        text: result.message,
      });
      this.errors = result.errors;
    }
  }

  public changeInput(key) {
    //  店舗会員が選択されたら、this.errors[password] と this.errors.[email]を削除
    const _errors = this.isEvent
      ? { ...this.errors, ...{ password: [], email: [] } }
      : this.errors;
    this.errors = { ..._errors, ...{ [key]: [] } };
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: `${this.$t("common.message.delete_confirm")}`,
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let message: any;
        try {
          const response = await memberApi.adminMemberDelete({
            id: this.memberId,
          });

          message = response.message;
          QNotify.success({
            text: message,
          });
          this.$router.go(-1);
        } catch (error) {
          message = error.body.message;
          QNotify.error({
            text: message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public cancel() {
    // check modifier form.
    const diff = compareWithKeys(
      this.form,
      this.originalForm,
      [
        "lastName",
        "firstName",
        "lastKana",
        "firstKana",
        "type",
        "companyName",
        "nickname",
        "zip",
        "address1",
        "address2",
        "address3",
        "tel",
        "telDaytime",
        "items",
        "email",
        "password",
        "language",
        "isNewsletter",
        "isNotice",
        "status",
        "statusConfirm",
      ],
      true,
    );

    if (!diff) {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        onConfirm: () => {
          this.$router.go(-1);
        },
      });
    } else {
      this.$router.go(-1);
    }
  }

  public onChangePostalCode(address) {
    this.form.address1 = address.pref_name + address.city_name;
    this.changeInput("address1");
  }

  public clearAddress() {
    this.form.address1 = null;
    this.form.address2 = null;
    this.form.address3 = null;
  }
}
